export interface WordGardenImageRequirement {
  readonly key: string;
  readonly path: string;
}

export const WORD_GARDEN_ASSET_REQUIREMENTS = {
  background: {
    key: 'word-garden-background',
    path: 'assets/story-forest/word-garden/backgrounds/word-garden-clearing.png',
  },
  pathOpen: {
    key: 'word-garden-path-open',
    path: 'assets/story-forest/word-garden/environments/word-garden-path-open.png',
  },
  foliageLeft: {
    key: 'word-garden-foreground-left',
    path: 'assets/story-forest/word-garden/environments/word-garden-foreground-left.png',
  },
  foliageRight: {
    key: 'word-garden-foreground-right',
    path: 'assets/story-forest/word-garden/environments/word-garden-foreground-right.png',
  },
  meaningSeed: {
    key: 'word-garden-meaning-seed',
    path: 'assets/story-forest/word-garden/interactives/meaning-seed.png',
  },
  meaningSeedSelected: {
    key: 'word-garden-meaning-seed-selected',
    path: 'assets/story-forest/word-garden/interactives/meaning-seed-selected.png',
  },
  plantDormant: {
    key: 'word-garden-meaning-plant-dormant',
    path: 'assets/story-forest/word-garden/plants/meaning-plant-dormant.png',
  },
  plantWilt: {
    key: 'word-garden-meaning-plant-wilt',
    path: 'assets/story-forest/word-garden/plants/meaning-plant-wilt.png',
  },
  plantBloom: {
    key: 'word-garden-meaning-plant-bloom',
    path: 'assets/story-forest/word-garden/plants/meaning-plant-bloom.png',
  },
  storyScroll: {
    key: 'word-garden-story-scroll',
    path: 'assets/story-forest/word-garden/ui/word-garden-scroll.png',
  },
  bloomVfx: {
    key: 'word-garden-bloom-vfx',
    path: 'assets/story-forest/word-garden/vfx/word-garden-bloom-vfx.png',
  },
} as const satisfies Record<string, WordGardenImageRequirement>;

export const WORD_GARDEN_ASSET_LIST = Object.values(WORD_GARDEN_ASSET_REQUIREMENTS);

export const WORD_GARDEN_PRODUCTION_READY: boolean = true;

export function preloadWordGardenAssets(scene: Phaser.Scene) {
  if (!WORD_GARDEN_PRODUCTION_READY) return;
  WORD_GARDEN_ASSET_LIST
    .filter(asset => !scene.textures.exists(asset.key))
    .forEach(asset => scene.load.image(asset.key, asset.path));
}

export function hasWordGardenProductionAssets(scene: Phaser.Scene) {
  return WORD_GARDEN_PRODUCTION_READY
    && WORD_GARDEN_ASSET_LIST.every(asset => scene.textures.exists(asset.key));
}

export function getMissingWordGardenAssets(scene: Phaser.Scene) {
  return WORD_GARDEN_ASSET_LIST.filter(asset => !scene.textures.exists(asset.key));
}
